
        <div class="no-content row">
                <ng-content></ng-content>
        </div>